import get from 'lodash/get'
import forEach from 'lodash/forEach'
import { flattenObject } from '../flatten-object'
import isNil from 'lodash/isNil'

export function templateReplace(template: string, templateVariables?: Record<any, any>) {
  //requiredCheck(template, 'template')
  if (isNil(template)) {
    return template
  }

  templateVariables = flattenObject(templateVariables, { array: true })

  let content = template
  forEach(templateVariables, (value, key) => {
    content = content.replaceAll(`{{${key}}}`, get(templateVariables, key))
  })

  return content
}
